import { IAppState } from '../../core/redux/IAppState';
import { API_ADD_USER } from '../../core/redux/api/endpoints';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { UserAr } from './userAr';
import { toUser } from './module';
import { assoc } from '../../language/module';


export const KEY_ACTION = ACTION_TYPE.ADD_USER_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.ADD_USER_REQUEST,
  ACTION_TYPE.ADD_USER_RESPONSE,
  ACTION_TYPE.ADD_USER_ERROR,
];

const mapToCreateUser = (user: UserAr) => ({
  userName: user.userName,
  email:    user.email,
  password: user.password,
  firstName: user.firstName,
  lastName: user.lastName,
  role: user.role,
  resortLocations: user.resortLocations,
  resetPassword: user.resetPassword,
  hasEmail: user.hasEmail,
})


/**
 * Creates an action to dispatch that adds a new user
 * @param user the details of the user being added
 */
export const addUserAction = (user: UserAr) => makeApiAction(
  {
    method:   'POST',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: (state: IAppState) => API_ADD_USER(state.userState.userId, state.selectedResort.resortId),
    body:     JSON.stringify(mapToCreateUser(user)),
    types:    ACTIONS.map(action => ({ type: action, meta: { user } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION) || !!getLoading(state, KEY_ACTION, KEY_ACTION),
  },
);


const reducer: ApiReducer<any> = (state, action, error, isLoading, payload) => {
  const newUser = action.meta.user as UserAr;

  if (isLoading) {
    return addLoading(state, newUser.userName, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, newUser.userName, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, newUser.userName, KEY_ACTION);

  newUser.userId = payload.userId;

  return assoc(
    'users',
    (noLoadingOrError.users || []).concat(toUser(newUser)),
    noLoadingOrError,
  );
};


export const addUserReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);
